<div class="card p-1">    
    <img src="./assets/globo.png" class="img-fluid" style="width: 20%; height: 20%; display: block; margin: auto;">
    <h3>GERAL</h3>
    <div class="card-body">
        <div *ngFor="let noticia of noticias">
            <div>
                <!-- Início Título da Notícia -->
                <p>
                    <a class="btn btn-danger btn-sm" data-toggle="collapse" [href]="'#' + noticia.area + noticia.id" role="button" aria-expanded="false" [attr.aria-controls]="noticia.area + noticia.id">
                        <i class="fas fa-plus"></i>
                    </a>
            
                    {{noticia.titulo}}
                </p>

                <!-- Fim Título da Notícia -->
            
                <!-- Início Conteúdo da Noticia -->
                <div class="collapse" [id]="noticia.area + noticia.id">
                    <div class="card card-body">
                      <p><strong>O que muda?</strong></p>
                        <p>
                          {{noticia.mudanca}}
                        </p>
                      <p></p>
                      <p><strong>A quem se aplica?</strong></p>
                      <p>
                          {{noticia.alvo}}
                      </p>
                      <p></p>
                      <p>Saiba mais <a [href]="noticia.link" target="blank">aqui.</a></p>
                </div>
                <!-- Fim Conteúdo da Noticia -->
            
            
                
            </div>
        </div>     
    </div>
</div>